import {
    ActivityRecordType,
    activityRecordTypes,
    type CrmMode,
    type CrmModeInfo,
} from "@sp-crm/core";

export { resolveCrmMode } from "@sp-crm/core";
export type { CrmMode, CrmModeInfo } from "@sp-crm/core";

export const recordTypesForCrmMode = (crmMode: CrmModeInfo): ActivityRecordType[] =>
    activityRecordTypes.filter(recordType => {
        switch (recordType) {
            case "placement":
            case "community":
                return crmMode.placementEnabled;
            case "homeCare":
                return crmMode.homeCareEnabled;
            case "referenceContact":
            case "referenceBusiness":
                return true;
        }
        const exhaustiveCheck: never = recordType;
        throw new Error(`Unhandled activity record type ${String(exhaustiveCheck)}`);
    });

export const placementClientsSettingsLabel = (mode: CrmMode): string =>
    mode === "combined" ? "Clients - Placement" : "Clients";

export const homeCareClientsSettingsLabel = (mode: CrmMode): string =>
    mode === "combined" ? "Clients - Home Care" : "Clients";

export const placementClientsFileShareLabel = (mode: CrmMode): string =>
    mode === "combined"
        ? "Can be shared with placement clients"
        : "Can be shared with clients";

export const homeCareClientsFileShareLabel = (mode: CrmMode): string =>
    mode === "combined"
        ? "Can be shared with home care clients"
        : "Can be shared with clients";
